import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { filter, map, take, takeWhile } from 'rxjs/operators';

import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { getFormWithId } from '@ordersnproducts/modules/multiple-order-online/redux/selectors/orders-forms.selector';

import OrdersFormsActions from '../../../redux/actions/orders-forms.action';

@Injectable()
export class UpdateValueCommand implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(
    newValue: any,
    formGroup: UntypedFormGroup,
    form: ConfigurableFormComponent,
    config: FieldConfig,
  ): void {
    formGroup.updateValueAndValidity({ emitEvent: false });
    const id = formGroup.get(SpecFieldNames.ID).value;
    const formControl = formGroup.get(config.name);
    const formValue$ = this.store.select(getFormWithId(id)).pipe(
      map((orderForm) => {
        const updateAlways =
          [SpecFieldNames.TEMPERATURE_UNDER, SpecFieldNames.SUMMER_SET].includes(config.name as SpecFieldNames) &&
          !!formControl;
        if (
          (orderForm &&
            orderForm.values[config.name] !== newValue &&
            !!formControl &&
            (formControl.dirty ||
              [
                SpecFieldNames.COLOR_INFO,
                SpecFieldNames.SPECIAL_INSTRUCTION,
                SpecFieldNames.TEMPERATURE_UNDER,
                SpecFieldNames.SUMMER_SET,
                SpecFieldNames.EXTRA_PRODUCTS,
              ].includes(config.name as SpecFieldNames))) ||
          updateAlways
        ) {
          this.store.dispatch(
            OrdersFormsActions.updateForm({
              formId: id,
              formControlName: config.name,
              formControlvalue: newValue,
              formIsValid: formGroup.valid,
            }),
          );
        }
      }),
      take(1),
    );
    let done = false;
    const status$ = formGroup.statusChanges.pipe(
      filter((status) => status !== 'PENDING'),
      map((status) => {
        done = true;
        formValue$.subscribe();
      }),
      takeWhile(() => done === false),
    );
    status$.subscribe();
  }
}
